import React, {useState, useCallback} from "react";
import {Button, Input, Space} from "antd";
import {AppstoreOutlined} from "@ant-design/icons";
import "./catalogue.item.scss"

export default function CatalogueItem({data, level = 1, OpenCourseModal, OpenCtgModal,onSort, children = null}) {
    const [collapsed, setCollapsed] = useState(false)
    const [sort, setSort] = useState(data.sort)
    const toggle = useCallback(() => {
        setCollapsed(!collapsed)
    })

    const onSortChange = useCallback(()=>{
        if (sort !== data.sort) {
            onSort(data.courseInfoId,sort)
        }
    })


    return (
        <>
            <div className="cursor flexbox align-center border-bottom pdv8"
                 style={{paddingLeft: (level - 1) * 32}}>
                <div className="flex1 flexbox align-center">
                    <Input className="text-center"
                           type="number"
                           min={0}
                           style={{borderRadius: 0, width: 20, height: 20, padding: 0}}
                           value={sort}
                           onChange={e=>setSort(e.target.value)}
                           onBlur={onSortChange}
                    />
                    <div onClick={toggle} className="flex1">
                        <AppstoreOutlined className="fts-18 gray-light mgl8"/>
                        <span
                            className={["bold", "mgl8", level === 1 ? "fts-16" : "fts-14"].join(' ')}>{data.courseInfoName}</span>
                    </div>
                </div>
                <Space>
                    <Button onClick={()=>OpenCtgModal(true)}>修改</Button>
                    {level === 1 && <Button onClick={()=>OpenCtgModal()}>创建二级目录</Button>}
                    <Button type="primary" onClick={OpenCourseModal}>创建内容</Button>
                </Space>
            </div>
            <div className="catalogue-content" style={{maxHeight: collapsed ? 0 : 2000}}>
                {children}
            </div>
        </>)
}
